import Blue from '~/core';

new Blue({
  name: 'Alert',
  selector: '.alert',
  setup(alert) {
    const id = `alert--${alert.getAttribute('id')}--dismissed`;
    const dismiss = alert.querySelector('.alert__close');
    const shouldDismiss = JSON.parse(localStorage.getItem(id) || 'false');

    if (shouldDismiss) doDismiss(true);
    else alert.classList.add('visible');
    if(dismiss) {
      this.$addEvents(dismiss, 'click.stop.prevent enter.stop.prevent', () =>
        doDismiss()
      );
    }

    function doDismiss(immediate = false) {
      localStorage.setItem(id, JSON.stringify(true));
      if (immediate) return alert.remove();
      let headerHeight = document.querySelector('header.header').offsetHeight;
      let alertHeight = alert.offsetHeight;
      let animation = alert.animate(
        [{ height: `${alertHeight}px` }, { height: `0px` }],
        {
          duration: 200,
          easing: 'ease',
          fill: 'forwards',
        }
      );
      adjustDrawerSize();
      animation.onfinish = () => alert.remove();

      function adjustDrawerSize() {
        const top = headerHeight - alertHeight;
        document.documentElement.style.setProperty(
          '--drawerHeight',
          `calc(100vh - ${top}px)`
        );
        document.documentElement.style.setProperty(
          '--headerHeight',
          `${top}px`
        );
      }
    }
  },
});
